import { useMutation, useQueryClient } from '@tanstack/react-query';

import { bulkApproveClaims, type IBulkApproveClaimsParams } from '@/services/admin';

export function useBulkApproveClaims() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (params: IBulkApproveClaimsParams) => bulkApproveClaims(params),
    onSuccess: (data) => {
      const anySucceeded = data.results.some((r) => r.success);
      if (anySucceeded) {
        void queryClient.invalidateQueries({ queryKey: ['adminClaims'] });
        void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      }
    },
  });

  return {
    bulkApprove: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error?.message ?? null,
    data: mutation.data ?? null,
    reset: mutation.reset,
  };
}
